import { render } from "./RegistrationAvatar.vue?vue&type=template&id=03b68324&scoped=true"
import script from "./RegistrationAvatar.vue?vue&type=script&lang=js"
export * from "./RegistrationAvatar.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationSteps.scss?vue&type=style&index=0&id=03b68324&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b68324"]])

export default __exports__